export const getErrorMessage = (error: string | undefined, defaultMessage: string): string => {
  if (!error) return defaultMessage;

  const errorLower = error.toLowerCase();

  if (errorLower.includes('invalid credentials') ||
      errorLower.includes('wrong password') ||
      errorLower.includes('incorrect password') ||
      errorLower.includes('invalid email or password')) {
    return 'Invalid email or password. Please check your credentials and try again.';
  }

  if (errorLower.includes('email already') ||
      errorLower.includes('already exists') ||
      errorLower.includes('user already exists')) {
    return 'An account with this email already exists. Please use a different email or log in.';
  }

  if (errorLower.includes('account not found') ||
      errorLower.includes('user not found')) {
    return 'No account found with this email address. Please check your email or sign up.';
  }

  if (errorLower.includes('account locked') ||
      errorLower.includes('account disabled')) {
    return 'Your account has been locked. Please contact support for assistance.';
  }

  if (errorLower.includes('not verified') ||
      errorLower.includes('verification required') ||
      errorLower.includes('verify your email')) {
    return 'Please verify your email address before logging in.';
  }

  if (errorLower.includes('invalid otp') ||
      errorLower.includes('wrong otp') ||
      errorLower.includes('incorrect otp')) {
    return 'Invalid verification code. Please check the code and try again.';
  }

  if (errorLower.includes('expired otp') ||
      errorLower.includes('otp expired')) {
    return 'Verification code has expired. Please request a new code.';
  }

  if (errorLower.includes('too many attempts') ||
      errorLower.includes('rate limit') ||
      errorLower.includes('too many requests')) {
    return 'Too many attempts. Please wait a few minutes before trying again.';
  }

  if (errorLower.includes('network') ||
      errorLower.includes('connection') ||
      errorLower.includes('failed to fetch')) {
    return 'Network error. Please check your internet connection and try again.';
  }

  if (errorLower.includes('password') &&
      (errorLower.includes('weak') ||
       errorLower.includes('requirements') ||
       errorLower.includes('strength'))) {
    return 'Password does not meet security requirements. Please use a stronger password.';
  }

  if (errorLower.includes('session') ||
      errorLower.includes('unauthorized') ||
      errorLower.includes('not authenticated')) {
    return 'Your session has expired. Please log in again.';
  }

  if (errorLower.includes('server error') ||
      errorLower.includes('internal error') ||
      errorLower.includes('500')) {
    return 'Server error occurred. Please try again later or contact support.';
  }

  if (errorLower.includes('timeout')) {
    return 'Request timed out. Please check your connection and try again.';
  }

  if (errorLower.includes('invalid token') ||
      errorLower.includes('token expired')) {
    return 'Security token is invalid or expired. Please request a new one.';
  }

  if (errorLower.includes('email not found')) {
    return 'No account found with this email address.';
  }

  return error;
};

export const getAuthErrorMessage = (error: string | undefined): string => {
  return getErrorMessage(error, 'Authentication failed. Please try again.');
};

export const getRegistrationErrorMessage = (error: string | undefined): string => {
  return getErrorMessage(error, 'Registration failed. Please try again.');
};

export const getOtpErrorMessage = (error: string | undefined): string => {
  return getErrorMessage(error, 'Verification failed. Please try again.');
};

export const getPasswordResetErrorMessage = (error: string | undefined): string => {
  return getErrorMessage(error, 'Password reset failed. Please try again.');
};
